import React from "react";

import { IToolbarContext, ToolbarContext } from "./ToolbarMenu";

interface IToolbarUpdaterProps {
    context: IToolbarContext;
}

class ViewToolbar extends React.Component<IToolbarUpdaterProps> {
    public componentDidMount() {
        const children = React.Children.map(this.props.children, c => React.isValidElement(c) ? React.cloneElement(c) : c);

        this.props.context.updateChildren(children);
    }

    public componentDidUpdate(prevProps: IToolbarUpdaterProps) {
        if (this.props.children !== prevProps.context.children) {
            this.props.context.updateChildren(this.props.children);
        }
    }

    public componentWillUnmount() {
        this.props.context.updateChildren(null);
    }

    public render() {
        return "";
    }
}

const ViewToolbarRoot = (props: any) => (
    <ToolbarContext.Consumer>
        {ctx => <ViewToolbar {...props} context={ctx} />}
    </ToolbarContext.Consumer>
);

export default ViewToolbarRoot;
